/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import Vue from 'vue';
import * as mTypes from 'store/mutation-types';
import { getApiPath } from '../../store-helpers';

const state = {
  parkings: [],
  limit: 5,
  keywordFilter: '',
  sortDuration: '',
  shortSearch: false,
};

const getters = {
  parkings: state => state.parkings,
  limit: state => state.limit,
  keywordFilter: state => state.keywordFilter,
  sortDuration: state => state.sortDuration,
  shortSearch: state => state.shortSearch,
};

const actions = {
  fetch({ commit }, payload) {
    const limit = `&limit=${payload.limit ? payload.limit : state.limit}`;
    let keyword = '';
    let dateFrom = '';
    let dateTo = '';
    let searchByPlate = '';
    let sort = '';

    if (state.sortDuration) {
      sort = `&sortDuration=${state.sortDuration}`;
    }

    if (payload.keyword) {
      commit(mTypes.SET_KEYWORD_FILTER, payload.keyword);
      keyword = `&q=${encodeURI(payload.keyword)}`;
    }
    if (payload.dateFrom && payload.dateTo) {
      dateFrom = `&dateFrom=${encodeURI(payload.dateFrom)}`;
      dateTo = `&dateTo=${encodeURI(payload.dateTo)}`;
    }

    if (payload.searchByPlate === 1
      || payload.searchByPlate === 0) {
      searchByPlate = `&searchByPlate=${encodeURI(payload.searchByPlate)}`;
    }

    return Vue.http.get(`${getApiPath(payload.user)}/parkings/list?${keyword}${limit}${searchByPlate}${dateFrom}${dateTo}${sort}`)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      });
  },
  fetchReport({ commit }, payload) {
    let startDate = '';
    let endDate = '';
    let productId = '';
    let vehicleReg = '';
    let zoneCode = '';
    let tenantIds = '';
    if (payload.data.startDate) {
      startDate = `startDate=${encodeURIComponent(payload.data.startDate)}`;
    }
    if (payload.data.endDate) {
      endDate = `&endDate=${encodeURIComponent(payload.data.endDate)}`;
    }
    if (payload.data.productId) {
      productId = `&productId=${encodeURIComponent(payload.data.productId)}`;
    }
    if (payload.data.vehicleReg) {
      vehicleReg = `&vehicleReg=${encodeURIComponent(payload.data.vehicleReg)}`;
    }
    if (payload.data.zoneCode) {
      zoneCode = `&zoneCode=${encodeURIComponent(payload.data.zoneCode)}`;
    }
    if (payload.data.tenantIds) {
      tenantIds = `&tenantId=${encodeURIComponent(payload.data.tenantIds)}`;
    }
    return Vue.http.get(`${getApiPath(payload.user)}/parkings/report?${startDate}${endDate}${productId}${vehicleReg}${zoneCode}${tenantIds}`, { data: payload.data })
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      });
  },
  toggleShortPlatesSearch({ commit }) {
    commit(mTypes.TOGGLE_SHORT_SEARCH);
  },
};

const mutations = {
  [mTypes.DATA_FETCHED](state, parkings) {
    state.parkings = parkings.data;
  },
  [mTypes.SET_LIMIT](state, limit) {
    state.limit = limit;
  },
  [mTypes.TOGGLE_SHORT_SEARCH](state) {
    state.shortSearch = !state.shortSearch;
  },
  [mTypes.SET_SORT_DURATION](state, sortDuration) {
    state.sortDuration = sortDuration;
  },
  [mTypes.REMOVE_DATA](state, parkingId) {
    const index = state.parkings.items.findIndex(obj => obj.id === parkingId);
    state.parkings.items.splice(index, 1);
    state.parkings.total -= 1;
  },
  [mTypes.REMOVE_DATAS](state, ids) {
    const items = state.parkings.items.filter((obj) => {
      const findItem = ids.find(id => id === obj.id);

      if (findItem) return false;
      return true;
    });

    state.parkings.items = items;
  },
  [mTypes.CLEAR_STATE](state) {
    state.parkings = [];
  },
  [mTypes.SET_KEYWORD_FILTER](state, keywordFilter) {
    state.keywordFilter = keywordFilter;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/landlord/parkings.js